function generatePlanOptionsErrors({ response, contactId }) {
  const availableContactId = contactId || 'contactId not yet available';
  const errorData = { response, contactId: availableContactId };
  window.datadogLogs.logger.error('Unable to reach insurance plans endpoint', errorData);
}

export default generatePlanOptionsErrors;
